import { IRequestDetailsModel } from './slice/types';

export function getServiceRequestTitle(
  requestDetails: Partial<IRequestDetailsModel>,
) {
  return `#${requestDetails.Id} - ${requestDetails.Service?.Name}`;
}
